import axios from './request.js'

const ip = '/api/v1';
// 本地调试ip，当在本地调试时，放开下面的ip，当在服务器使用用上面的
// const ip = 'http://localhost:8090/api/v1';

const api = {
	// 登录
	login: params => axios.post(ip + '/login', params),
	// 登出
	logout: params => axios.get(ip + '/logout', params),
	// 接入oidc登录
	oidcLogin: params => axios.get(ip + '/oidc'),
	// 获取app列表
	getAppList: params => axios.get(ip + '/app/getAppList', params),
	// 获取单个app
	getApp: params => axios.get(ip + '/app/getAppByCode', params),
	// 删除app
	deleteApp: params => axios.delete(ip + '/app/deleteAppByCode', params),
	// 保存app
	saveApp: params => axios.post(ip + '/app/saveApp', params),
	// 修改app
	updateApp: params => axios.put(ip + '/app/updateAppByCode', params),
	// 获取动态配置资源
	getDynamicResourceList: params => axios.get(ip + '/dynamic-resource', params),
	// 新增动态配置资源
	saveDynamicResource: params => axios.post(ip + '/dynamic-resource', params),
	// 删除动态配置资源
	deleteDynamicResource: params => axios.delete(ip + '/dynamic-resource', params),
	// 修改动态配置资源
	updateDynamicResource: params => axios.put(ip + '/dynamic-resource', params),
	// 获取当前系统登录人name
	getCurrentSystemLoginUser: params => axios.get(ip + '/user/getCurrentSystemLoginUser', params),
	// 获取configurations的keys
	getConfigurationKeys: params => axios.get(ip + '/configurations/keys', params),
	// 获取configurations的applications
	getConfigurationApplications: params => axios.get(ip + '/configurations/applications', params),
	// 获取configurations的labels
	getConfigurationLabels: params => axios.get(ip + '/configurations/labels', params),
	// 获取configurations
	getConfigurationList: params => axios.get(ip + '/configurations', params),
	// 新增configurations
	saveConfiguration: params => axios.post(ip + '/configurations', params),
	// 获取远程配置的attribute
	getAttributeList: params => axios.get(ip + '/remote-config/attributes', params),
	// 获取远程配置列表
	getRemoteConfigList: params => axios.get(ip + '/remote-config', params),
	// 新增远程配置
	saveRemoteConfig: params => axios.post(ip + '/remote-config', params),
	// 修改远程配置
	updateRemoteConfig: params => axios.put(ip + '/remote-config', params),
	// 修改远程配置
	deleteRemoteConfig: params => axios.delete(ip + '/remote-config', params),
	// 获取环境配置
	getEnvOptions: params => axios.get(ip + '/getEnvs', params),
};

export default api;